import React from 'react';
import { motion } from 'framer-motion';
import { HeartIcon } from 'lucide-react';
export function LauraSection() {
  return <section className="py-20 bg-laura-beige text-laura-dark" data-id="element-143">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-144">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.8
      }} className="bg-white rounded-3xl shadow-lg p-8 md:p-12 flex flex-col md:flex-row items-center gap-10 md:gap-14" data-id="element-145">
          {/* Laura's Photo */}
          <div className="flex-shrink-0" data-id="element-146">
            <div className="relative" data-id="element-147">
              <div className="absolute -inset-2 bg-laura-olive/20 rounded-full" data-id="element-148" />
              <div className="w-40 h-40 md:w-48 md:h-48 rounded-full overflow-hidden border-4 border-white shadow-xl relative" data-id="element-149">
                {/* Placeholder — replace with Laura's real photo */}
                <img src="https://cdn.magicpatterns.com/uploads/a3QZ4WeekrJxwFi3qUA52c/Captura_de_pantalla_2026-03-12_a_las_21.37.13.png" alt="Laura, propietaria de El Rincón de Laura" className="w-full h-full object-cover" data-id="element-150" />
              </div>
            </div>
          </div>

          {/* Text Content */}
          <div className="text-center md:text-left" data-id="element-151">
            <div className="flex items-center justify-center md:justify-start gap-2 mb-3" data-id="element-152">
              <HeartIcon className="w-4 h-4 text-laura-olive" data-id="element-153" />
              <span className="text-laura-olive text-sm font-bold uppercase tracking-[0.2em]" data-id="element-154">
                El alma del restaurante
              </span>
            </div>

            <h2 className="text-3xl md:text-4xl font-playfair text-laura-wood mb-6 leading-tight" data-id="element-155">
              Laura, tu anfitriona
            </h2>

            <div className="space-y-4 text-laura-wood/80 font-light leading-relaxed" data-id="element-156">
              <p className="text-lg" data-id="element-157">
                Detrás de cada plato y cada detalle está Laura, el corazón de
                este rincón. Con su trato cercano y su sonrisa, consigue que
                cada cliente se sienta como en casa desde el primer momento.
              </p>
              <p data-id="element-158">
                Su pasión por la cocina tradicional y su dedicación al cuidado
                de cada mesa hacen que volver sea siempre una alegría. Muchos de
                nuestros clientes ya son parte de la familia, y eso es mérito de
                ella.
              </p>
            </div>

            <motion.p initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.4,
            duration: 0.8
          }} className="mt-6 text-laura-olive font-playfair italic text-lg" data-id="element-159">
              "Aquí no vienes solo a comer, vienes a disfrutar"
            </motion.p>
          </div>
        </motion.div>
      </div>
    </section>;
}